import { render, staticRenderFns } from "./CreateOrEditAdminInspectBusiness.vue?vue&type=template&id=128d3785&scoped=true&"
import script from "./CreateOrEditAdminInspectBusiness.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditAdminInspectBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d3785",
  null
  
)

export default component.exports